export const Actions = {
  LIST_REMINDER_PROFILES: "LIST_REMINDER_PROFILES",
  LIST_REMINDER_PROFILES_SUCCEEDED: "LIST_REMINDER_PROFILES_SUCCEEDED",
  LIST__REMINDERS: "LIST__REMINDERS",
  LIST__REMINDERS_SUCCEEDED: "LIST__REMINDERS_SUCCEEDED",
  LIST_ASSIGNEES: "LIST_ASSIGNEES",
  LIST_ASSIGNEES_SUCCEEDED: "LIST_ASSIGNEES_SUCCEEDED",
  LIST_PRODUCER_CODES: "REMINDER/LIST_PRODUCER_CODES",
  LIST_PRODUCER_CODES_SUCCEEDED: "REMINDER/LIST_PRODUCER_CODES_SUCCEEDED",
  SET_SELECTED_ROWS: "SET_SELECTED_ROWS_MANAGE",
  CLEAR_SELECTED_ROWS: "CLEAR_SELECTED_ROWS_MANAGE",
  READ_REMINDER_DETAILS: "READ_REMINDER_DETAILS",
  READ_REMINDER_DETAILS_SUCCEEDED: "READ_REMINDER_DETAILS_SUCCEEDED",
  SET_ACTIVE_TAB: "SET_ACTIVE_TAB",
  CLEAR_REMINDER_PROFILES: "CLEAR_REMINDER_PROFILES",
  SET_SEARCH_VALUES: "REMINDER/SET_SEARCH_VALUES",
  CLEAR_REMINDER_LIST: "CLEAR_REMINDER_LIST",
  CLEAR_SELECTED_REMINDER: "CLEAR_SELECTED_REMINDER",
  CLEAR_OPERATION_RESULT: "CLEAR_OPERATION_RESULT",
  BULK_ASSIGN_REMINDERS: "BULK_ASSIGN_REMINDERS",
  BULK_ASSIGN_REMINDERS_SUCCEEDED: "BULK_ASSIGN_REMINDERS_SUCCEEDED",
  BULK_UPDATE_PRODUCER_CODE: "BULK_UPDATE_PRODUCER_CODE",
  BULK_UPDATE_PRODUCER_CODE_SUCCEEDED: "BULK_UPDATE_PRODUCER_CODE_SUCCEEDED",
  CLEAR_BULK_ASSIGN_DATA: "CLEAR_BULK_ASSIGN_DATA",
  CLEAR_BULK_PRODUCER_UPDATE_DATA: "CLEAR_BULK_PRODUCER_UPDATE_DATA",
  CLEAR_BULK_PRODUCER_TARGETS: "CLEAR_BULK_PRODUCER_TARGETS",
};
